export function firstOfSet<T>(set: Set<T>): T | undefined {
  return set.values().next().value as T | undefined
}

export function isDefined(value: any) {
  return value !== undefined || value !== null || value !== '' || !Number.isNaN(value)
}

export function filterAndFormatParams(params: Record<string, any>) {
  return Object.entries(params).filter(([value]) => isDefined(value)).map(([key, value]) => `${key}=${value}`)
}
